<template>
    <div>
        <limitless-page-header :loading="!initialized && busy_loading">
            <template #header-elements>
                <limitless-page-header-button url="/cardseries" icon="icon-list-unordered">Korterier</limitless-page-header-button>
            </template>
        </limitless-page-header>
        <div class="content" v-if="!initialized && busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="!not_found && card_series.length>0">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-xs">
                        <thead>
                        <tr>
                            <th>Serie</th>
                            <th>Benämning</th>
                            <th>Antal kort</th>
                            <th>Status</th>
                            <th>Kvar</th>
                            <th>Aktiverat</th>
                            <th>I Lager</th>
                            <th>Skapa</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(card_serie, cs_idx) in card_series" :key="'cs-' + cs_idx">
                                <td>{{ card_serie.CardSeriesID }}</td>
                                <td>{{ card_serie.SeriesName }}</td>
                                <td>{{ card_serie.NextSerial-1 }}</td>
                                <td v-bind:style="{ 'color': (card_serie.actualamount!==card_serie.NextSerial-1 ? '#CC0000' : 'inherit' )}">{{ card_serie.actualamount }}</td>
                                <td>
                                    <span v-if="card_serie.CardSeriesID<1000">{{ (99999-(card_serie.NextSerial-1)) }}</span>
                                    <span v-else-if="card_serie.CardSeriesID>=1000 && card_serie.CardSeriesID<=4929">{{ (99999-(card_serie.NextSerial-1)) }}</span>
                                    <span v-else>{{ (9999-(card_serie.NextSerial-1)) }}</span>
                                </td>
                                <td>{{ card_serie.activatedamount }}</td>
                                <td>{{ card_serie.actualamount-card_serie.activatedamount }}</td>
                                <td style="width: 140px;">
                                    <input type="number" class="form-control" v-model="card_series_generate[card_serie.CardSeriesID].amount" :disabled="card_serie.actualamount!==(card_serie.NextSerial-1)">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <limitless-button ref="btngenerate" :busy="busy_generating" saved-text="KLAR!" @click="generateCards">Generera</limitless-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-else-if="not_found">
            <i>Kunde ej hämta kortserier</i>
        </div>
        <div class="content" v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import Vue from 'vue';

export default {
    name: 'CardNumberGenerator',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_generating: false,
        card_series: null,
        card_series_generate: [],
    }),
    mounted() {
        this.getCardSeries();
    },
    methods: {
        async getCardSeries() {
            const vm = this;
            this.busy_loading = true;

            await apiClient.get('/vue/cardseries?only_series=1&include_card_count=1&per_page=10000')
                .then((response) => {
                    const cardSeriesGenerate = {};
                    Object.values(response.data.data).forEach((cardSeries) => {
                        cardSeriesGenerate[cardSeries.CardSeriesID] = {
                            card_series_id: cardSeries.CardSeriesID,
                            amount: 0,
                        };
                    });
                    Vue.set(vm, 'card_series_generate', cardSeriesGenerate);
                    Vue.set(vm, 'card_series', response.data.data);
                })
                .catch(() => {
                    Vue.set(vm, 'not_found', true);
                })
                .finally(() => {
                    Vue.set(vm, 'busy_loading', false);
                    Vue.set(vm, 'initialized', true);
                });
        },
        async generateCards() {
            const vm = this;
            vm.busy_generating = true;
            await apiClient.post('/vue/cardseries/generate_cards', {
                card_series: vm.card_series_generate,
            }).then(() => {
                vm.getCardSeries();
                vm.$refs.btngenerate.triggerSaved();
            }).catch(() => {
                vm.$refs.btngenerate.triggerFailed();
            }).finally(() => {
                vm.busy_generating = false;
            });
        },
    },
};
</script>
